import {
    setPlattype
} from "config/functions"
const selectedYear = localStorage.getItem("selected_year")
const initialState = {
    isLoading: false,
    // NOTES: temporary change default selected date to 2020
    // selected_year: selectedYear ? Number(selectedYear) : new Date().getFullYear() ,
    selected_year: selectedYear ? Number(selectedYear) : 2020,
    selected_planttype: localStorage.getItem("select_planttype"),
    options_planttype: [],
}

const navbarReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_OPTIONS_PLANTTYPE": {
            return {
                ...state,
                options_planttype: action.data,
            }
        }
        case "SELECT_PLANTTYPE": {
            setPlattype(action.data);

            return {
                ...state,
                selected_planttype: action.data
            }
        }
        case "SELECT_YEAR":
            localStorage.setItem("selected_year", action.data)
            return { ...state, selected_year: action.data }

        default: {
            return state
        }
    }
}

export default navbarReducer;
